import { schema } from 'normalizr';

const options = { idAttribute: '_id' };

const contactDetailTypeSchema = new schema.Entity('contactDetailTypes', {}, options);
const contactDetailTypeListSchema = [contactDetailTypeSchema];

const eventTypeSchema = new schema.Entity('eventTypes', {}, options);
const eventTypeListSchema = [eventTypeSchema];

const partnerEventFileSchema = new schema.Entity('partnerEventFiles', {}, options);
const partnerEventFileListSchema = [partnerEventFileSchema];

const chatSchema = new schema.Entity('chats', {}, options);
const chatListSchema = [chatSchema];

const userSchema = new schema.Entity('users', {}, options);
const userListSchema = [userSchema];

const firebaseUserSchema = new schema.Entity('firebaseUsers', {}, options);
const firebaseUserListSchema = [firebaseUserSchema];

const chatMessageSchema = new schema.Entity('chatMessages', {}, options);
const chatMessageListSchema = [chatMessageSchema];

const evacuationTypeSchema = new schema.Entity('evacuationTypes', {}, options);
const evacuationTypeListSchema = [evacuationTypeSchema];

const eventSubTypeSchema = new schema.Entity('eventSubTypes', {}, options);
const eventSubTypeListSchema = [eventSubTypeSchema];

const eventSourceSchema = new schema.Entity('eventSources', {}, options);
const eventSourceListSchema = [eventSourceSchema];

const roleSchema = new schema.Entity('roles', {}, options);
const roleListSchema = [roleSchema];

const contactDetailSchema = new schema.Entity('contactDetails', {
  type: contactDetailTypeSchema
}, options);
const contactDetailListSchema = [contactDetailSchema];

const languageSchema = new schema.Entity('languages', {}, options);
const languageListSchema = [languageSchema];

const hashtagSchema = new schema.Entity('hashtags', {}, options);
const hashtagListSchema = [hashtagSchema];

const dutySchema = new schema.Entity('duties', {}, options);
const dutyListSchema = [dutySchema];

const standardReportRowSchema = new schema.Entity('standardReportRows', {}, options);
const standardReportRowListSchema = [standardReportRowSchema];

const genderSchema = new schema.Entity('genders', {}, options);
const genderListSchema = [genderSchema];

const regionSchema = new schema.Entity('regions', {}, options);
const regionListSchema = [regionSchema];

const regionSchemaFix = new schema.Entity('regions', {}, options);
const regionListSchemaFix = [regionSchemaFix];

const countrySchema = new schema.Entity('countries', {
  regions: regionListSchema
}, options);
const countryListSchema = [countrySchema];

// Fixing denormilizr recursive bug
const countrySchemaFix = new schema.Entity('countries', {}, options);
const countryListSchemaFix = [countrySchemaFix];

const partnerRelationshipSchema = new schema.Entity('partnerRelationships', {}, options);
const partnerRelationshipListSchema = [partnerRelationshipSchema];

const partnerReviewSchema = new schema.Entity('partnerReviews', {}, options);
const partnerReviewListSchema = [partnerReviewSchema];

const partnerTypeSchema = new schema.Entity('partnerTypes', {}, options);
const partnerTypeListSchema = [partnerTypeSchema];

const standardSchema = new schema.Entity('standards', {
  partnerType: partnerTypeSchema
}, options);
const standardListSchema = [standardSchema];

const standardGroupSchema = new schema.Entity('standardGroups', {
  standards: standardListSchema
}, options);
const standardGroupListSchema = [standardGroupSchema];

// Fixing denormilizr recursive bug
const standardGroupSchemaFix = new schema.Entity('standardGroups', {}, options);
const standardGroupListSchemaFix = [standardGroupSchemaFix];

const mapMarkerTypeSchema = new schema.Entity('mapMarkerTypes', {}, options);
const mapMarkerTypeListSchema = [mapMarkerTypeSchema];

const contactSchema = new schema.Entity('contacts', {
  contactDetails: contactDetailListSchema,
  languages: languageListSchema
}, options);
const contactListSchema = [contactSchema];

const partnerSchema = new schema.Entity('partners', {
  reviews: partnerReviewListSchema,
  types: partnerTypeListSchema,
  relationship: partnerRelationshipSchema,
  contactDetails: contactDetailListSchema,
  contacts: contactListSchema,
  countries: countryListSchemaFix,
  regions: regionListSchema
}, options);
const partnerListSchema = [partnerSchema];

const translatorSchema = new schema.Entity('translators', {
  contactDetails: contactDetailListSchema,
  contacts: contactListSchema,
  languages: languageListSchema
}, options);
const translatorListSchema = [translatorSchema];

const customerSchema = new schema.Entity('customers', {
  contactDetails: contactDetailListSchema
}, options);
const customerListSchema = [customerSchema];

const insuranceCompanySchema = new schema.Entity('insuranceCompanies', {}, options);
const insuranceCompanyListSchema = [insuranceCompanySchema];

const aranSchema = new schema.Entity('arans', {}, options);
const aranListSchema = [aranSchema];

const eventSchema = new schema.Entity('events', {
  countries: countryListSchemaFix,
  regions: regionListSchema,
  partners: partnerListSchema,
  translators: translatorListSchema,
  chat: chatSchema,
  mainCustomer: customerSchema
}, options);
const eventListSchema = [eventSchema];

const activityLogSchema = new schema.Entity('activityLogs', {
  user: userSchema
}, options);
const activityLogListSchema = [activityLogSchema];

countrySchema.define({
  partners: partnerListSchema,
  standardGroup: standardGroupSchema
});

regionSchema.define({
  standardGroup: standardGroupSchema
})

export default {
  contactSchema,
  contactListSchema,
  contactDetailTypeSchema,
  contactDetailTypeListSchema,
  eventTypeSchema,
  eventTypeListSchema,
  eventSubTypeSchema,
  eventSubTypeListSchema,
  eventSourceSchema,
  eventSourceListSchema,
  roleSchema,
  roleListSchema,
  firebaseUserSchema,
  firebaseUserListSchema,
  contactDetailSchema,
  contactDetailListSchema,
  languageSchema,
  languageListSchema,
  countrySchema,
  countryListSchema,
  countrySchemaFix,
  countryListSchemaFix,
  regionSchema,
  regionListSchema,
  regionSchemaFix,
  regionListSchemaFix,
  genderSchema,
  genderListSchema,
  mapMarkerTypeSchema,
  mapMarkerTypeListSchema,
  partnerRelationshipSchema,
  partnerRelationshipListSchema,
  partnerReviewSchema,
  partnerReviewListSchema,
  partnerTypeSchema,
  partnerTypeListSchema,
  partnerSchema,
  partnerListSchema,
  translatorSchema,
  translatorListSchema,
  eventSchema,
  eventListSchema,
  insuranceCompanySchema,
  insuranceCompanyListSchema,
  aranSchema,
  aranListSchema,
  customerSchema,
  customerListSchema,
  userSchema,
  userListSchema,
  chatSchema,
  chatListSchema,
  chatMessageSchema,
  chatMessageListSchema,
  dutySchema,
  dutyListSchema,
  hashtagSchema,
  hashtagListSchema,
  standardSchema,
  standardListSchema,
  standardGroupSchema,
  standardGroupListSchema,
  standardGroupSchemaFix,
  standardGroupListSchemaFix,
  activityLogSchema,
  activityLogListSchema,
  evacuationTypeSchema,
  evacuationTypeListSchema,
  standardReportRowSchema,
  standardReportRowListSchema,
  partnerEventFileSchema,
  partnerEventFileListSchema
}


// WEBPACK FOOTER //
// ./src/normalizrSchema.js